module.exports = __webpack_public_path__ + "static/media/change_policy.84bbf8cb.svg";